import React, {useEffect, useState} from 'react'
import Sport1 from './Sport1'
import Sport2 from './Sport2'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
const cateToCn = {
    beauty:'美妝',
    sport:'運動塑身',
    family:'家居及育兒',
    fasion:'時尚',
  }
function App({popName,handleStartScan}){
    const [caroIdx, setCaroIdx] = useState(0)
    return(
        <div className='w-[100%]'>
            {/* {caroIdx === 0 && <img src={'/images/missioninfo.png'} className='border'></img>}
            {caroIdx === 1 && <img src={'/images/missioninfo2.png'} className='border'></img>} */}
            <div className='absolute w-[55%] top-[27%] left-[23%]'>
                <Carousel selectedItem={caroIdx} className='w-full h-full' showStatus={false} showIndicators={false} showThumbs={false} showArrows={false} onChange={(idx) => setCaroIdx(idx)}>
                    <div className='w-full h-full flex flex-col items-center justify-center'>
                        {popName === 'fasion' && <img src="/images/btn/qricon2.png" className='w-full scale-[120%]'/>}
                        {popName === 'sport' && <img src="/images/btn/qricon3.png" className='w-full scale-[120%]'/>}
                        {popName === 'beauty' && <img src="/images/btn/qricon1.png" className='w-full scale-[120%]'/>}
                        {popName === 'family' && <img src="/images/btn/qricon4.png" className='w-full scale-[120%]'/>}
                        <div className='w-[100%] text-[12px] text-center font-[500]'>到達{cateToCn[popName]}部並搜尋此特別版{cateToCn[popName]}達人QR Code，便完成任務，距離完成任務一大步！</div>
                    </div>
                    <div className='w-full h-full flex flex-col items-center justify-center relative' style={{gap:12}}>
                        <div className='w-[30%]'>
                            <img src='/images/tipstop.png' className='w-[100%]'></img>
                        </div>
                        <div className='text-[#133460] font-bold text-[18px]'>試試於收銀處尋找吧！</div>
                        <div className='w-[70%]'>
                            <img src='/images/cashicon.jpg' className='w-full scale-120'></img>
                        </div>
                        
                    </div>
                </Carousel>
            </div>
            <div onClick={handleStartScan} className='w-[45%] h-[6%] absolute top-[61%] left-[28%]'></div>
            <div className='absolute w-[80%] h-[10%] top-[68.7%] left-[10%]' style={{zIndex:2}}>
                <Carousel selectedItem={caroIdx} className='w-full h-full flex flex-row items-center justify-center' showStatus={false} showArrows={false} showIndicators={false} showThumbs={false} onChange={(idx) => setCaroIdx(idx)}>
                        <div className='w-full h-full flex flex-row items-start justify-center'>
                            <img src='/images/tiptext1.png' className='max-w-[75%]'></img>
                        </div>
                        <div className='w-full h-full flex flex-row items-start justify-center'>
                            <img src='/images/tiptext2.png' className='max-w-[80%]'></img>
                        </div>
                </Carousel>
            </div>
            <img src={'/images/missioninfonew.png'} className='w-full min-w-[100vw]' style={{objectFit:'contain'}}></img>

            {/* {caroIdx === 0 && <img src='/images/tiptext1.png' className='absolute top-[71%] left-[10%] w-[80%]'></img>}
            {caroIdx === 1 && <img src='/images/tiptext2.png' className='absolute top-[71%] left-[10%] w-[80%]'></img>} */}
        </div>
    )
}
export default App